"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATA_UI_DESCRIPTION_METADATA = exports.DATA_UI_S3FILE_CONFIG_METADATA = exports.DATA_UI_TEXT_LENGTH_METADATA = exports.DATA_UI_ENUM_VALUES_FROM_PICKLIST_METADATA = exports.DATA_UI_ENUM_VALUES_WITH_KEYS_METADATA = exports.DATA_UI_ENUM_VALUES_METADATA = exports.DATA_UI_SEARCH_CONFIG_METADATA = exports.DATA_UI_LAYOUT_CONFIG_METADATA = exports.DATA_UI_PERMISSIONS_METADATA = exports.DATA_UI_ADDITIONAL_ACTION = exports.DATA_UI_NAME_METADATA = void 0;
exports.DATA_UI_NAME_METADATA = 'gid:name';
exports.DATA_UI_ADDITIONAL_ACTION = 'gid:action';
exports.DATA_UI_PERMISSIONS_METADATA = 'gid:permissions';
exports.DATA_UI_LAYOUT_CONFIG_METADATA = 'gid:layout-config';
exports.DATA_UI_SEARCH_CONFIG_METADATA = 'gid:search-config';
exports.DATA_UI_ENUM_VALUES_METADATA = 'gid:enum-values';
exports.DATA_UI_ENUM_VALUES_WITH_KEYS_METADATA = 'gid:enum-values-with-keys';
exports.DATA_UI_ENUM_VALUES_FROM_PICKLIST_METADATA = 'gid:picklist-enum-values';
exports.DATA_UI_TEXT_LENGTH_METADATA = 'gid:text-length';
exports.DATA_UI_S3FILE_CONFIG_METADATA = 'gid:s3file-config';
exports.DATA_UI_DESCRIPTION_METADATA = 'gid:description';
//# sourceMappingURL=constants.js.map